import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import ManagerWorkplaceOnlineOrderTargetSetup from './ManagerWorkplaceOnlineOrderTargetSetup';

interface Props extends BaseModalProps {
	workplaceId: string;
	defaultData: {
		onlineOrderTarget: string;
	};
	onUpdate: () => void;
}

const ManagerWorkplaceOnlineOrderTargetSetupModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.managerWorkplaceOnlineOrderTargetSetupModal.title'>
			<ManagerWorkplaceOnlineOrderTargetSetup
				workplaceId={props.workplaceId}
				defaultData={props.defaultData}
				onUpdate={props.onUpdate}
			/>
		</BaseModal>
	);
};

export default ManagerWorkplaceOnlineOrderTargetSetupModal;
